import axios from 'axios';

export const GET_TRANSFERS = '/transfers/getTransfersList';
export const GET_TRANSFERS_EXCEL = '/transfers/getTransfersListForExcel';

export function getTransfers(queryParams, cancellationHandlers) {
  return axios.get(GET_TRANSFERS, {params: queryParams, ...cancellationHandlers});
}

export function getTransfersForExcelFile(queryParams) {
  return axios.get(GET_TRANSFERS_EXCEL, {params: queryParams});
}